import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from './connection.service';
import { ConfigService } from './endpoint.config.service';
import { promise } from 'protractor';
import { Observable, Subject } from 'rxjs';
import { resolve } from 'url';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class UtilitiesService extends ConnectionService {
  currentLocationId: any;
  constructor(http: HttpClient, private configs: ConfigService, private toaster: ToastrService) {
    super(http);

    if (this.currentLocationId == undefined && sessionStorage.getItem("company") != undefined)
      this.currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
  }
  getCountries(sucFun, errFun) {
    this.CallApi("get", this.configs.getAppApiUrl("GET_COUNTRIES").replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      var initalList = res.Results as any[];
      var countries = [] as any[];
      for (var i = 0; i < initalList.length; i++) {
        countries.push({ key: initalList[i].Name, value: initalList[i].Code, hasStates: initalList[i].HasStates, postCodeRequired: initalList[i].PostCodeRequired, postCodeMasks: initalList[i].PostCodeMasks })
      }
      sucFun(countries)
    }, (err) => {
      errFun(err)
    })
  }
  getCurrencies(sucFun, errFun) {
    this.CallApi("get", this.configs.getAppApiUrl("GET_CURRENCIES").replace("{{currentLocationId}}", this.currentLocationId), {}, null, (res) => {
      var initalList = res.Results as any[];
      var currencies = [] as any[];
      for (var i = 0; i < initalList.length; i++) {
        currencies.push({ key: initalList[i].Alias, value: initalList[i].Code, Factor: initalList[i].Factor, IsoNumber: initalList[i].IsoNumber, Name: initalList[i].Name, Symbol: initalList[i].Symbol, Units: initalList[i].Units })
      }
      sucFun(currencies);
    }, (err) => {
      errFun(err);
    });
  }
  getStatesByCountryCode(city, countryCode, sucFun, errFun) {
    this.CallApi("get", this.configs.getAppApiUrl("GET_STATES").replace("{{countryCode}}", countryCode).replace("{{currentLocationId}}", this.currentLocationId), { startsWith: city, take: 1000, skip: 0 }, null,
      (res) => {
        var initalList = res.Results as any[];
        var states = [] as any[];
        for (var i = 0; i < initalList.length; i++) {
          states.push({ key: initalList[i].Name, value: initalList[i].Code })
        }
        sucFun(states)
      },
      (err) => {
        errFun(err)

      })
  }
  getCityNameByStateAndCountryCode(countryCode, stateName, sucFun, errFun) {
    var requestBody = { stateName: stateName };
    if (requestBody.stateName == "N/A")
      delete requestBody.stateName;

    this.CallApi("get", this.configs.getAppApiUrl("GET_CITIES").replace("{{countryCode}}", countryCode).replace("{{currentLocationId}}", this.currentLocationId), requestBody, null,
      (res) => {
        var initalList = res.Results as any[];
        var cities = [] as any[];
        for (var i = 0; i < initalList.length; i++) {
          cities.push({ key: initalList[i].Name, value: initalList[i].StateName })
        }
        sucFun(cities)
      },
      (err) => { })
  }
  resolveAddress(requestObj, sucFun, errFun): Observable<any> {
    var addressOb = new Subject();
    var address = addressOb as Observable<any>
    this.CallApi('post', this.configs.getAppApiUrl('RESOLVE_ADDRESS').replace("{{currentLocationId}}", this.currentLocationId), requestObj, null,

      (res) => {
        addressOb.next(res)
      },
      (err) => {
        try {
          errFun(err.error[0])
        }
        finally {

        }
      })

    return address;
  }

getShortCodeSetting(): Observable<any> {  
  return new Observable((observer) => {
    this.CallApi(
      'get',
      this.configs.getAppApiUrl('GET_SHORT_CODE_SETTINGS')
        .replace("{{currentLocationId}}", this.currentLocationId),
      null,
      null,
      (res) => {
        observer.next(res);
        observer.complete();
      },
      (err) => {
        observer.error(err.error?.[0] || err);
      }
    );
  });
}

  resolveShortCode(requestObj, sucFun, errFun) {
    this.CallApi('post', this.configs.getAppApiUrl('RESOLVE_SHORT_CODE').replace("{{currentLocationId}}", this.currentLocationId), requestObj, null,
      (res) => {
        sucFun(res)
      },
      (err) => {
        try {
          errFun(err.error[0])
        }
        finally {

        }
      })
  }


  resolvePhone(requestObj, sucFun, errFun) {
    this.CallApi('post', this.configs.getAppApiUrl('RESOLVE_PHONE').replace("{{currentLocationId}}", this.currentLocationId), requestObj, null,

      (res) => {
        sucFun(res)
      },
      (err) => {
        try {
          errFun(err.error[0])
        }
        finally {

        }
      })
  }
  getContactByPhoneNumber(phoneNumber, sucFun, errFun) {
    var endpoint = this.configs.getAppApiUrl('GET_CONTACTS_BY_PHONE_NUMBER').replace('{{phoneNumber}}', phoneNumber).replace("{{currentLocationId}}", this.currentLocationId);
    this.CallApi('get', endpoint, {}, null, (res) => {
      sucFun(res)
    }, (err) => {
      try {
        errFun(err.error[0])
      }
      finally {

      }
    })
  }
  getPostCodes(countryCode, postCode, sucFun, errFun) {
    var requestBody = { postCode: postCode, productGroup: 'EXP' };
    var endPoint = this.configs.getAppApiUrl("GET_POST_CODES").replace("{{countryCode}}", '' + countryCode + '').replace("{{currentLocationId}}", this.currentLocationId);
    this.CallApi("get", endPoint, requestBody, null,
      (res) => {
        sucFun(res);
      },
      (err) => {
        errFun(err);
      })

  }


}
